import { map, sum } from 'lodash'
import React, { useMemo } from 'react'
import { ReactElement } from 'react'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import InlineEditorInvalid from '../../../../../../../1stlog-ui/src/components/InlineEditor/InlineEditorInvalid'
import { formatDecimalNumber } from '../../../../../../../1stlog-ui/src/utils/format'
import { getVolume } from '../../../../../../helpers/measurementHelpers'
import { useProductSettings } from '../../../../Products'

type TTotalVolumeProps = {
  readonly?: boolean
}

const TotalVolume = (props: TTotalVolumeProps): ReactElement => {
  const { readonly } = props

  const { isMeasurementsHidden } = useProductSettings()

  const colis = useField('colis')

  const value = useMemo(() => sum(map(colis, (v) => getVolume(v))), [colis])

  if (isMeasurementsHidden) {
    return <></>
  }

  return (
    <div className="text-center">
      <div>
        <Label>{i18n.t('total_volume', 'Gesamtvolumen')}</Label>
      </div>
      <h4 className={readonly ? 'mt-1' : 'mt-2'}>
        {isNaN(value) ? (
          <InlineEditorInvalid />
        ) : (
          <span>{formatDecimalNumber(parseFloat(String(value)), 0, 3)} m³</span>
        )}
      </h4>
    </div>
  )
}

export default TotalVolume
